// src/pages/UsersPage.tsx
import { useState } from "react";
import UserList from "../components/UserList";
import UserManagement from "../components/UserManagement";

const UsersPage = () => {
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="container px-4 pb-4 pt-4 w-full mx-auto">
        <div className="mt-12 flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold mb-6">Gestión de Usuarios</h1>
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-brand-primary hover:brightness-90 text-white font-bold py-2 px-4 rounded"
        >
          Crear nuevo usuario
        </button>
        </div>

      <UserList />

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center overflow-y-auto h-full w-full p-4">
          <div className="bg-white p-4 rounded-lg shadow-lg w-full h-[80%] max-w-xl overflow-y-auto">
            <UserManagement
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersPage;